<template>
  <div class="auction-wrap">
    <template v-if="!token">
      <div class="type-wrap" @click="handleToList">
        <span class="type-title">竞价中心</span>
        <span class="tag">放心拍服务</span>
        <div class="country-wrap">
          <div
            class="country-item"
            v-for="(item, index) in auctionTypeList"
            :key="index"
          >
            <span
              :style="{
                color:
                  auctionType == item.code
                    ? 'rgba(254, 118, 72, 1)'
                    : 'rgba(29, 32, 137, 1)',
              }"
              class="country-name"
              >{{ item.name }}</span
            >
          </div>
        </div>
        <div class="more-wrap">
          查看更多<span class="el-icon-arrow-right" />
        </div>
      </div>
      <div class="steps-wrap">
        <div class="steps-title">竞价流程</div>
        <div class="steps-content-wrap">
          <div
            v-for="(item, index) in stepsList"
            :key="index"
            class="step-item"
          >
            <div
              class="icon-wrap"
              :style="`background-image:url(${item.url})`"
            ></div>
            <div class="step-detail">
              <div class="step-num">{{ item.num }}</div>
              <div class="step-desc">{{ item.desc }}</div>
            </div>
            <div v-if="index < 5" class="step-arrow">
              <span style="font-weight: 700" class="el-icon-arrow-right"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="content-wrap">
        <div :class="[listLength > 3 ? 'img-wrap ' : 'img-wrapThree']"></div>
        <div
          class="detail-wrap"
          v-for="(item, index) in list"
          :key="index"
          @click="$emit('login', true)"
        >
          <div class="img-wrap">
            <el-image
              style="width: 100%; height: 100%"
              :src="item.Pic"
              fit="cover"
            ></el-image>
            <div class="sg-tag" :class="item.StatusCode | bgClass">
              {{ item.StatusName }}
            </div>
          </div>
          <div class="detail-text-wrap">
            <div class="auction-name">{{ item.Title }}</div>
            <div class="price-wrap">
              <span class="price-text">{{
                item.StatusCode | pricePrompt
              }}</span>
              <span class="price-value" v-if="item.AuctionNum == 0">0</span>
              <span class="price-value" v-if="item.AuctionNum">{{
                item.StatusCode | priceValue(item)
              }}</span>
              <span class="price-action">({{ item.AuctionNum }}次出价)</span>
            </div>
            <div class="desc-wrap">{{ item.tips }}</div>
          </div>
        </div>
        <div
          class="timeEndBox"
          v-if="
            listLength == 1 ||
            listLength == 2 ||
            listLength == 4 ||
            listLength == 5
          "
          @click="$emit('login', true)"
        >
          <div class="imgBox">
            <img src="@/assets/tourist/pigBackground.png" alt="" />
          </div>
          <div class="tipText">已经结束了~下次早点来哦~</div>
        </div>
        <div
          class="EndMoreBox"
          v-if="listLength == 1 || listLength == 4"
          @click="$emit('login', true)"
        >
          <div class="imgBox">
            <el-icon class="el-icon-arrow-right icon"></el-icon>
          </div>
          <div class="tipText">查看更多</div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="logined-auction-tab">
        <div class="title">
          <span>竞价中心</span><span class="tag">低价捡漏区</span>
        </div>
        <div class="tab-wrap">
          <div class="tab-item" @click="handleToAuction('partComponent')">
            <span>配件</span>
            <span class="tag">放心拍服务</span>
          </div>
          <div class="tab-item" @click="handleToAuction('standingComponent')">
            <span>发动机</span>
            <span class="tag">好货抢先拍</span>
          </div>
          <div class="tab-item" @click="handleToAuction('colorComponent')">
            <span>有色</span>
            <span class="tag">买到就赚到</span>
          </div>
          <div class="tab-item" @click="handleToAuction('tyreComponent')">
            <span>轮胎</span>
            <span class="tag">放心拍服务 </span>
          </div>
        </div>
      </div>
      <div class="logined-content-wrap">
        <div
          @click="handleToDetail(item)"
          class="detail-wrap"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="img-wrap">
            <el-image
              style="width: 100%; height: 100%"
              :src="item.Pic"
              fit="cover"
            ></el-image>
            <div class="sg-tag" :class="item.StatusCode | bgClass">
              <!-- {{ item.StatusCode | statusTip }} -->
              {{ item.StatusName }}
            </div>
          </div>
          <div class="detail-text-wrap">
            <div class="auction-name">
              <span class="fx-tag" style="margin-right: 10px">放心拍</span
              >{{ item.Title }}
            </div>
            <div class="price-wrap">
              <span class="price-text">{{
                item.StatusCode | pricePrompt
              }}</span>
              <span class="price-value" v-if="item.AuctionNum == 0">{{
                0
              }}</span>
              <span class="price-value" v-if="item.AuctionNum">{{
                item.StatusCode | priceValue(item)
              }}</span>
              <span class="price-action">({{ item.AuctionNum }}次出价)</span>
            </div>
            <div class="desc-wrap">{{ item.tips }}</div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
// import { QueryAuctionUnLogin } from "@/api/merchant/dashboard";
import { dealListByDate } from "@/utils/index";
import { mapGetters } from "vuex";
export default {
  inject: ["getAuctionList"],
  computed: {
    list() {
      if (dealListByDate(this.getAuctionList()) != undefined) {
        console.log(dealListByDate(this.getAuctionList()).length);
        this.listLength = dealListByDate(this.getAuctionList()).length;
      }

      console.log(this.getAuctionList(), this.listLength);
      return dealListByDate(this.getAuctionList());
    },
    ...mapGetters(["token"]),
  },

  filters: {
    bgClass: function (value) {
      switch (value) {
        case "DPM":
          return "dpm-bg";
        case "JPZ":
          return "jxz-bg";
        default:
          return "js-bg";
      }
    },
    pricePrompt: function (value) {
      switch (value) {
        case "DPM":
          return "起始价";
        case "JPZ":
          return "当前价";
        default:
          return "结束价";
      }
    },
    priceValue: function (value, item) {
      switch (value) {
        case "DPM":
          return item.StartAccount;
        default:
          return item.StartAccount > item.UserAuctionAccount
            ? item.StartAccount
            : item.UserAuctionAccount;
      }
    },
  },

  data() {
    return {
      listLength: 0,

      auctionTypeList: [
        { name: "配件", code: "VehicleAuction" },
        { name: "发动机", code: "StandingAuction" },
        { name: "有色", code: "WeightAuction" },
        { name: "轮胎", code: "TyreAuction" },
      ],
      auctionType: "VehicleAuction",
      stepsList: [
        {
          url: require("@/assets/tourist/step_1.png"),
          num: "第一步",
          desc: "查看详情",
        },
        {
          url: require("@/assets/tourist/step_2.png"),
          num: "第二步",
          desc: "交保证金",
        },
        {
          url: require("@/assets/tourist/step_3.png"),
          num: "第三步",
          desc: "参与竞价",
        },
        {
          url: require("@/assets/tourist/step_4.png"),
          num: "第四步",
          desc: "竞价成功",
        },
        {
          url: require("@/assets/tourist/step_5.png"),
          num: "第五步",
          desc: "线下交易",
        },
        {
          url: require("@/assets/tourist/step_6.png"),
          num: "第六步",
          desc: "等待收货",
        },
      ],
      handleToAuction(e) {
        this.$router.push({ path: "/badding", query: { type: e } });
      },
      handleToDetail(e) {
        const { AuctionTypeCode, ID, MctCode } = e;
        console.log(e);
        let type = "";
        switch (AuctionTypeCode) {
          case "AutoPartsAuction":
            type = "part";
            break;
          case "WeightAuction":
          case "TyreAuction":
            type = "color";
            break;
          default:
            type = "standing";
        }
        console.log(type);
        this.$router.push({
          path: "/vehicleSource",
          query: {
            type,
            ID,
            MctCode,
            AuctionTypeCode,
          },
        });
      },
    };
  },
  created() {
    // let test=this.list
    // debugger
    //   let test=this.list
    // QueryAuctionUnLogin().then((res) => {
    //   debugger;
    // });
  },
  methods: {
    handleToList() {
      if (!this.token) {
        this.$emit("login", true);
        // return true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.sg-tag {
  width: 92px;
  height: 27px;
  opacity: 1;
  border-radius: 500px 0px 0px 500px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  position: absolute;
  top: 30px;
  right: 0;
  display: flex;
  align-items: center;
  padding-left: 20px;
}
.tag {
  position: relative;
  // padding: 15px 12px 15px 7px;
  padding-left: 7px;
  padding-right: 12px;
  padding-top: 5px;
  padding-bottom: 5px;
  background: linear-gradient(
    90deg,
    rgba(249, 212, 35, 1) 0%,
    rgba(248, 54, 0, 1) 100%
  );
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  border-radius: 6px;
  margin-left: 18px;
  &::before {
    position: absolute;
    content: "";
    border-width: 6px;
    border-style: solid;
    border-color: transparent rgba(249, 212, 35, 1) transparent transparent;
    left: -12px;
    top: 50%;
    transform: translateY(-50%);
  }
}
.dpm-bg {
  background: linear-gradient(
    90deg,
    rgba(37, 117, 252, 1) 0%,
    rgba(106, 17, 203, 1) 100%
  );
}
.jxz-bg {
  background: linear-gradient(
    90deg,
    rgba(249, 212, 35, 1) 0%,
    rgba(248, 54, 0, 1) 100%
  );
}
.js-bg {
  background: rgba(176, 177, 177, 1);
}
.auction-wrap {
  .type-wrap {
    position: relative;
    margin-bottom: 15px;
    padding: 7px 20px 7px 27px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 1);
    display: flex;
    align-items: center;
    .type-title {
      font-size: 26px;
      font-weight: 500;
      color: rgba(29, 32, 137, 1);
    }
    // .tag {
    //   position: relative;
    //   // padding: 15px 12px 15px 7px;
    //   padding-left: 7px;
    //   padding-right: 12px;
    //   padding-top: 5px;
    //   padding-bottom: 5px;
    //   background: linear-gradient(
    //     90deg,
    //     rgba(249, 212, 35, 1) 0%,
    //     rgba(248, 54, 0, 1) 100%
    //   );
    //   font-size: 14px;
    //   font-weight: 400;
    //   color: rgba(255, 255, 255, 1);
    //   border-radius: 6px;
    //   margin-left: 18px;
    //   &::before {
    //     position: absolute;
    //     content: "";
    //     border-width: 6px;
    //     border-style: solid;
    //     border-color: transparent rgba(249, 212, 35, 1) transparent transparent;
    //     left: -12px;
    //     top: 50%;
    //     transform: translateY(-50%);
    //   }
    // }
    .country-wrap {
      display: flex;
      margin-left: 40px;
      //   .active {
      //     color: rgba(254, 118, 72, 1);
      //   }
      .country-item {
        cursor: pointer;
        & + .country-item {
          margin-left: 40px;
        }

        display: flex;
        align-items: center;
        .country-name {
          font-size: 20px;
          font-weight: 600;
          //   color: rgba(29, 32, 137, 1);
        }
      }
    }
    .more-wrap {
      cursor: pointer;
      position: absolute;
      font-size: 16px;
      font-weight: 400;
      color: rgba(56, 56, 56, 1);
      right: 20px;
    }
  }
  .steps-wrap {
    height: 100px;
    display: grid;
    grid-template-columns: 105px auto;
    border-radius: 10px;
    background: rgba(255, 255, 255, 1);
    border: 3px solid rgba(29, 32, 137, 1);
    margin-bottom: 15px;
    .steps-title {
      margin-top: -3px;
      margin-left: -3px;
      padding: 14px 28px;
      border-radius: 10px;
      background: rgba(23, 9, 115, 1);
      font-size: 24px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
    }
    .steps-content-wrap {
      padding-left: 43px;
      display: grid;
      grid-template-columns: repeat(6, auto);
      .step-item {
        display: flex;
        align-items: center;
        .icon-wrap {
          width: 63px;
          height: 63px;
          background-color: rgba(29, 32, 137, 1);
          border-radius: 50%;
          background-image: url("~@/assets/tourist/step_1.png");
          background-position: center;
          background-repeat: no-repeat;
        }
        .step-detail {
          margin-left: 11px;
          .step-num {
            font-size: 16px;
            font-weight: 400;
            color: rgba(29, 32, 137, 1);
          }
          .step-desc {
            font-size: 20px;
            font-weight: 700;
            color: rgba(29, 32, 137, 1);
          }
        }
        .step-arrow {
          font-size: 35px;
          font-weight: 700;
          color: rgba(29, 32, 137, 1);
          margin-left: 15px;
        }
      }
    }
  }
  .content-wrap-unLogin {
    .img-wrap {
      position: relative;
      // grid-row: 1/3;
      border-radius: 10px;
      // background-image: url("~@/assets/dash_common/cheyuan.png");
      // background-image: url("https://img.js.design/assets/img/634514ebf2fd1d82d58d5dd6.png#2f20a2588f168a8cd75087e6674cfb54");
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
    }
    .detail-wrap {
      cursor: pointer;
      background-color: white;
      border-radius: 10px;
      padding: 0 0 13px;
      overflow: hidden;

      .img-wrap {
        height: 180px;
      }
      .img-wrap-length3 {
        height: 180px;
      }
      .detail-text-wrap {
        padding: 5px 15px;
        .auction-name {
          font-size: 16px;
          font-weight: 400;
          color: rgba(56, 56, 56, 1);
        }
        .price-wrap {
          margin-top: 5px;
          .price-text {
            font-size: 10px;
            font-weight: 400;
            color: rgba(56, 56, 56, 1);
          }
          .price-value {
            margin-left: 15px;
            position: relative;
            font-size: 24px;
            font-weight: 700;
            color: rgba(254, 118, 72, 1);
            &::before {
              content: "￥";
            }
          }
          .price-action {
            margin-left: 10px;
            font-size: 12px;
            font-weight: 400;
            color: rgba(128, 128, 128, 1);
          }
        }
        .desc-wrap {
          font-size: 12px;
          font-weight: 400;
          color: rgba(56, 56, 56, 1);
        }
      }

      //   .detail-content-wrap {
      //     padding: 17px 8px 8px 17px;
      //     .tag-wrap {
      //       margin-bottom: 8px;
      //       .tag {
      //         padding: 3px 13px;
      //         border-radius: 30px;
      //         color: white;
      //         &:nth-of-type(1) {
      //           background-color: rgba(0, 186, 173, 1);
      //         }
      //         &:nth-of-type(2) {
      //           background-color: rgba(176, 177, 177, 1);
      //         }
      //         & + .tag {
      //           margin-left: 10px;
      //         }
      //       }
      //     }
      //     .vehicle-wrap {
      //       font-size: 15px;
      //       font-weight: 500;
      //       color: rgba(56, 56, 56, 1);
      //       word-break: break-all;
      //     }
      //   }
    }
  }
  .logined-content-wrap,
  .content-wrap {
    display: grid;
    // grid-template-columns: 310px auto auto auto;
    grid-template-columns: 310px 1fr 1fr 1fr;
    // grid-template-rows: repeat(2, 275px);

    grid-gap: 0px 10px;
    .EndMoreBox {
      cursor: pointer;
      margin-top: 10px;
      background: #ffffff;
      border-radius: 10px;
      .imgBox {
        position: relative;
        margin: 34px auto 0 auto;
        width: 163px;
        height: 163px;
        border-radius: 50%;
        background: linear-gradient(to right, #2674fb, #6912cc);
        .icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: #fff;
          font-size: 64px;
        }
      }
      .tipText {
        margin-top: 15px;
        font-size: 18px;
        text-align: center;
        // font-weight: 700;
        color: #807e7e;
      }
    }
    .timeEndBox {
      cursor: pointer;
      margin-top: 10px;
      background: #ffffff;
      border-radius: 10px;
      .imgBox {
        margin: 22px auto 0 auto;
        width: 177px;
        height: 177px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .tipText {
        margin-top: 13px;
        font-size: 18px;
        text-align: center;
        font-weight: 700;
        color: #fe7648;
      }
      // background: pink;
      // background: url("../../../assets/tourist/pigBackground.png");
    }
    .img-wrap {
      position: relative;
      grid-row: 1/3;
      border-radius: 10px;
      // background-image: url("~@/assets/dash_common/cheyuan.png");
      background-image: url("https://img.js.design/assets/img/634514ebf2fd1d82d58d5dd6.png#2f20a2588f168a8cd75087e6674cfb54");
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      height: 100%;
    }
    .img-wrapThree {
      position: relative;
      grid-row: 1/3;
      border-radius: 10px;
      // background-image: url("~@/assets/dash_common/cheyuan.png");
      background-image: url("../../../assets/bg.png");
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      height: 100%;
    }

    .detail-wrap {
      cursor: pointer;
      background-color: white;
      border-radius: 10px;
      padding: 0 0 13px;
      margin-top: 10px;
      overflow: hidden;

      .img-wrap {
        height: 180px;
      }
      .img-wrap-length3 {
        height: 180px;
      }
      .detail-text-wrap {
        padding: 5px 15px;
        .auction-name {
          font-size: 16px;
          font-weight: 400;
          color: rgba(56, 56, 56, 1);
        }
        .price-wrap {
          margin-top: 5px;
          .price-text {
            font-size: 10px;
            font-weight: 400;
            color: rgba(56, 56, 56, 1);
          }
          .price-value {
            margin-left: 15px;
            position: relative;
            font-size: 24px;
            font-weight: 700;
            color: rgba(254, 118, 72, 1);
            &::before {
              content: "￥";
            }
          }
          .price-action {
            margin-left: 10px;
            font-size: 12px;
            font-weight: 400;
            color: rgba(128, 128, 128, 1);
          }
        }
        .desc-wrap {
          font-size: 12px;
          font-weight: 400;
          color: rgba(56, 56, 56, 1);
        }
      }

      //   .detail-content-wrap {
      //     padding: 17px 8px 8px 17px;
      //     .tag-wrap {
      //       margin-bottom: 8px;
      //       .tag {
      //         padding: 3px 13px;
      //         border-radius: 30px;
      //         color: white;
      //         &:nth-of-type(1) {
      //           background-color: rgba(0, 186, 173, 1);
      //         }
      //         &:nth-of-type(2) {
      //           background-color: rgba(176, 177, 177, 1);
      //         }
      //         & + .tag {
      //           margin-left: 10px;
      //         }
      //       }
      //     }
      //     .vehicle-wrap {
      //       font-size: 15px;
      //       font-weight: 500;
      //       color: rgba(56, 56, 56, 1);
      //       word-break: break-all;
      //     }
      //   }
    }
  }
  .logined-content-wrap {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: auto;
    margin-top: 15px;
    .detail-wrap {
      .img-wrap {
        height: 252px;
      }
      .fx-tag {
        padding: 1px 8px;
        line-height: 12px;
        border-radius: 30px;
        background: linear-gradient(
          90deg,
          rgba(37, 117, 252, 1) 0%,
          rgba(106, 17, 203, 1) 100%
        );
        font-size: 12px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
  .logined-auction-tab {
    background-color: white;
    height: 50px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    .title {
      width: 295px;
      height: 50px;
      border-radius: 10px;
      background: rgba(254, 118, 72, 1);
      font-size: 26px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding-left: 28px;
      .tag {
        background-color: white;
        background-image: none;
        font-size: 14px;
        font-weight: 400;

        color: rgba(254, 118, 72, 1);
        &::before {
          border-color: transparent #fff transparent transparent;
          // background-color: white;
          // background-image: none;
        }
      }
    }
    .tab-wrap {
      flex: 1;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      font-size: 26px;
      font-weight: 500;
      color: rgba(29, 32, 137, 1);
      // justify-items: center;
      // display: flex;
      // justify-content: space-around;
      .tab-item {
        cursor: pointer;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        .tag {
          background-image: none;
          background-color: white;
          border: 2px solid rgba(29, 32, 137, 1);
          font-size: 14px;
          font-weight: 400;
          color: rgba(29, 32, 137, 1);
          padding-top: 3px;
          padding-bottom: 3px;
          &::before {
            border-color: transparent rgba(29, 32, 137, 1) transparent
              transparent;
          }
          &::after {
            position: absolute;
            content: "";
            border-width: 6px;
            border-style: solid;
            border-color: transparent white transparent transparent;
            left: -9px;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }
      .tab-item + .tab-item {
        border-left: 2px solid rgba(29, 32, 137, 1);
      }
    }
  }
}
</style>
